import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2
};

const strokePropsRound = {
  ...strokeProps,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const BrowserIcon = createSvgIcon(
  <>
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      {...strokeProps}
    />
    <path d="M2.5 9H21.5" {...strokePropsRound} />
    <path d="M6.99981 6H7.00879" {...strokePropsRound} />
    <path d="M10.9998 6H11.0088" {...strokePropsRound} />
  </>,
  { displayName: 'BrowserIcon', viewBox: '0 0 24 24' }
);
